import React, { memo } from 'react';

import Fade from '@material-ui/core/Fade';
import Snackbar from '@material-ui/core/Snackbar';
import PropTypes from 'prop-types';

const CrmSnackbar = (props) => {
  const { autoHideDuration, TransitionComponent, open, onClose, anchorOrigin, message, action, children, ...rest } = props;

  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={open}
      TransitionComponent={TransitionComponent}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
      message={message}
      action={action}
      {...rest}
    >
      {children}
    </Snackbar>
  );
};

CrmSnackbar.propTypes = {
  /** anchorOrigin: position of the snackbar */
  anchorOrigin: PropTypes.object,
  /** TransitionComponent: a material ui transition component */
  TransitionComponent: PropTypes.elementType,
  /** open: if true, element is open */
  open: PropTypes.bool,
  /** onClose */
  onClose: PropTypes.func,
  /** autoHideDuration: snackbars hides after x ms, set to null to disable */
  autoHideDuration: PropTypes.number,
  /** message: the message to display*/
  message: PropTypes.node,
  /** action: the action to display, renders after the message */
  action: PropTypes.node,
  /** children: modal content */
  children: PropTypes.element,
};

CrmSnackbar.defaultProps = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
  TransitionComponent: Fade,
  open: true,
  onClose: () => {},
  autoHideDuration: 5000,
};

export default memo(CrmSnackbar);
